import React from 'react';
import { useState, useEffect, useRef } from 'react';
import downarrow from '../../images/common/bluedownarrow.png'
import uparrow from '../../images/common/blueuparrow.png'
import '../../scss/reusables/multi-selection-dropdown.scss'
import search from '../../images/common/search.png';
import { trim } from '../Reusables/Function';


function ClickOutside(ref, setDropdownCliked) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
            setDropdownCliked(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
}

function MultiSelectionDropdown({selectedItem, label, list, 
    handleLabel, selectedBrand}) {

    const dropdownwrapperRef = useRef(null);
    const [isDropdownCliked, setDropdownCliked] = useState(false);
    ClickOutside(dropdownwrapperRef, setDropdownCliked);
    const [searchData, setSearchData] = useState("");
    const [dropdownList, setDropdownList] = useState([]);
    const [searchList, setSearchList] = useState([]);
    const [brandId, setBrandId] = useState(0);

    const[propertiesCheckedState, setPropertiesCheckedState] = useState({});


    const handleDropdown = () => {
        setDropdownCliked(!isDropdownCliked);
    }

    const handleSearchData = (query) => {
        setSearchData(query);
    }

    const handleEnterkey = (event) => {
        if (event.key == 'Enter') {
            event.preventDefault();
            setSearchData(searchData);
        }
    }

    useEffect(() => {
        if(list != null && list.length > 0) {
            setDropdownList(list);
            setSearchList(list);

            const initialCheckedState = {};
            
            list.forEach(item => {
                initialCheckedState[item.propertyCode] = {
                    id: item.id,
                    checked: false
                };
            });
    
            if (label !== "Select Property") {
                const propertyCodes = label.split(', ');
                propertyCodes.forEach(propertyCode => {
                    for (let i = 0; i < list.length; i++) {
                        if (list[i].propertyCode == propertyCode) {
                            initialCheckedState[list[i].propertyCode].checked = true;
                        }
                    }
                });
            }
            
            setPropertiesCheckedState(initialCheckedState);
        }
    }, [list])

    useEffect(() => {
        console.log("[MULTI] Selected ", selectedBrand);
        if(dropdownList.length > 0 && selectedBrand != 0) {
            setBrandId(selectedBrand);
        }
    }, [dropdownList, selectedBrand])

    useEffect(() => {
        if(dropdownList.length > 0 && searchData != null) {
            const filteredList = dropdownList.filter((item) => {
                const brandCondition = brandId !== 0 ? (item.brandId == brandId || item.parentBrand == brandId) : true;
                const searchCondition = searchData == "" ? true : item.name.toLowerCase().includes(searchData.toLowerCase());
                return brandCondition && searchCondition;
            });
              
            setSearchList(filteredList);
        }
    }, [dropdownList, searchData, brandId])

    const handleCheckbox = (selected) => {
        const updatedPropertiesCheckedState = { ...propertiesCheckedState };

        if (updatedPropertiesCheckedState[selected.propertyCode].checked !== undefined) {
            updatedPropertiesCheckedState[selected.propertyCode].checked = !updatedPropertiesCheckedState[selected.propertyCode].checked;
        }

        setPropertiesCheckedState(updatedPropertiesCheckedState);

        const selectedIds = Object.keys(updatedPropertiesCheckedState)
            .filter(key => updatedPropertiesCheckedState[key].checked === true)
            .map(key => updatedPropertiesCheckedState[key].id);

        const selectedPropertyCodes = Object.keys(updatedPropertiesCheckedState)
            .filter(key => updatedPropertiesCheckedState[key].checked === true);

        var selectedPropertiesString = selectedPropertyCodes.join(', ');

        selectedItem(selectedIds);
        handleLabel(selectedPropertiesString);

        if(selectedIds.length > 0) {
            setBrandId(selected.parentBrand ? selected.parentBrand : selected.brandId);
        } else {
            setBrandId(0);
            handleLabel("Select Property");
        }
    }

    
    return (
        <div className='multi-selection-dropdown' ref={dropdownwrapperRef}>
            {console.log("[MULTI] Search list ", searchList)}
            <div className='dropdown-name-img' onClick={handleDropdown}>
                <div className='dropdown-name'>{label}</div>
                <img className='arrow' src={isDropdownCliked ? uparrow : downarrow} alt=""></img>
            </div>
            {isDropdownCliked && (
                <>
                    <div className='dropdown-search'>
                        <div className='dropdown-search-container'>
                            <input type="text" value={searchData} placeholder="Search Property" onChange={(e) => handleSearchData(e.target.value)}
                                onKeyDown={(e) => handleEnterkey(e)}></input>
                            <img src={search} alt="searchicon" onClick={() => handleSearchData(searchData)}></img>
                        </div>
                    </div>
                    <div className='checkbox properties-checkbox'>
                    {searchList != null && searchList.length > 0 && searchList.map((item, index) => {
                        return (
                            <>
                                <div className='properties-checkbox-container'>
                                    <label className='properties-checkbox-label'>
                                        {propertiesCheckedState != null && <input className='inputcheckbox' type="checkbox" onChange={(e) => handleCheckbox(item)} 
                                        checked={propertiesCheckedState[item.propertyCode].checked}/>}
                                        <span className="checkmark"></span>
                                        <span className="title">{item.name}</span>
                                    </label>
                                </div>
                            </>
                        )
                    })}
                    </div>
                </>
            )}
        </div>
    );
}

export default MultiSelectionDropdown;